module.exports = __webpack_public_path__ + "selo-garantia.svg";